(function() {
  'use strict';

  var drawer = document.getElementById('product-drawer');
  if (!drawer) return;

  var body = drawer.querySelector('[data-drawer-body]');
  var closeButtons = drawer.querySelectorAll('[data-drawer-close]');

  function open(blockId) {
    var tpl = document.querySelector('template[data-drawer-cards="' + blockId + '"]');
    if (!tpl) return;

    body.innerHTML = '';
    var grid = document.createElement('div');
    grid.className = 'product-drawer__cards';
    grid.appendChild(tpl.content.cloneNode(true));
    var cardCount = grid.querySelectorAll('.card-ma11').length;
    if (cardCount > 0) {
      grid.classList.add('product-drawer__cards--count-' + cardCount);
    }

    if (!grid.children.length) {
      body.innerHTML = '<p class="product-drawer__empty">No products to show.</p>';
    } else {
      body.appendChild(grid);
    }

    drawer.setAttribute('aria-hidden', 'false');
    $s.hideScroll();
    $s.trapFocus(drawer.querySelector('.product-drawer__panel'));
  }

  function close() {
    drawer.setAttribute('aria-hidden', 'true');
    $s.showScroll();
    $s.removeTrapFocus();
  }

  closeButtons.forEach(function(el) {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      close();
    }
  });

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-drawer-trigger]');
    if (!trigger) return;
    var blockId = trigger.dataset.blockId;
    if (!blockId) return;
    e.preventDefault();
    open(blockId);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var trigger = e.target.closest('[data-drawer-trigger]');
    if (!trigger) return;
    var blockId = trigger.dataset.blockId;
    if (!blockId) return;
    e.preventDefault();
    open(blockId);
  });

  window.ProductDrawer = { open: open, close: close };
})();
